function fitBanner() {
  const header = document.querySelector('[data-header]');
  if (header) document.documentElement.style.setProperty('--header-height', `${header.getBoundingClientRect().height}px`);
}

let headerObserver;
function observeHeader() {
  headerObserver?.disconnect();
  const header = document.querySelector('[data-header]');
  if (header) {
    headerObserver = new ResizeObserver(fitBanner);
    headerObserver.observe(header);
  }
  fitBanner();
}

function updateVariant(select) {
  const section = select.closest('[data-product-section]');
  const option = select.selectedOptions[0];
  if (!option || !section) return;
  const price = section.querySelector(`[data-price-for="${option.value}"]`);
  if (price) section.querySelector('[data-price]').replaceChildren(price.content.cloneNode(true));
  const quantity = section.querySelector('[name="quantity"]');
  quantity.min = option.dataset.min || '1';
  quantity.step = option.dataset.step || '1';
  if (option.dataset.max) quantity.max = option.dataset.max;
  else quantity.removeAttribute('max');
  quantity.value = quantity.min;
  const submit = section.querySelector('[data-product-submit]');
  if (submit) {
    submit.disabled = option.dataset.available !== 'true';
    submit.textContent = submit.disabled ? submit.dataset.unavailableLabel : submit.dataset.availableLabel;
  }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
  const media = document.getElementById(option.dataset.media);
  if (media) {
    section.querySelector('.product-gallery').prepend(media);
  }
}

document.addEventListener('change', event => {
  if (event.target.matches('[data-variant-select]')) updateVariant(event.target);
});
document.addEventListener('shopify:section:load', observeHeader);
observeHeader();
